export default "__VITE_ASSET__CPGX$38u__"